import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminApp from "./admin/AdminApp";

export default function App() {
  return (
    <Routes>
      {/* POS domain should open admin */}
      <Route path="/" element={<Navigate to="/admin-login" replace />} />

      {/* Admin app handles /admin-login, /admin, /dashboard, etc */}
      <Route path="/*" element={<AdminApp />} />

      {/* fallback */}
      <Route path="*" element={<Navigate to="/admin-login" replace />} />
    </Routes>
  );
}
